
import Autoplay from "slotworks/state-machine/standard/states/autoplay";

export default class GameiomAutoplay extends Autoplay {

}
